const dropOutApply = {
  path: 'dropOutApply',
  component: resolve => require(['../../../../components/pages/studentUnion/dropOutApply'], resolve)
}

export default dropOutApply
